module.exports = __webpack_public_path__ + "img/logo-novonesis.2b5baaa4.svg";